import { memo } from 'react';
import { BRAZIL_STATE_MINI_PATHS, STATE_MINI_MAP_VIEW_BOX } from '../../../constants/brazilStatePaths';
import styles from './StateMiniMapSVG.module.css';

interface StateMiniMapSVGProps {
	stateCode: string;
	isSelected: boolean;
}

export const StateMiniMapSVG = memo(({ stateCode, isSelected }: StateMiniMapSVGProps) => {
	const path = BRAZIL_STATE_MINI_PATHS[stateCode];

	if (!path) return <span className={styles.fallback}>{stateCode}</span>;

	return (
		<svg viewBox={STATE_MINI_MAP_VIEW_BOX} className={styles.svg} preserveAspectRatio="xMidYMid meet" aria-hidden>
			<path d={path} className={`${styles.statePath} ${isSelected ? styles.stateSelected : styles.stateBase}`} />
		</svg>
	);
});

StateMiniMapSVG.displayName = 'StateMiniMapSVG';
